import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { importProvidersFrom, inject, provideEnvironmentInitializer } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from 'environments/environment';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from 'app/core/http.interceptor';
import { errorInterceptor } from 'app/core/error.interceptor';
import { RxStomp } from '@stomp/rx-stomp';
import { rxStompFactory } from '@services/websocket/rx-stomp-factory';
import { BrowserCloseService } from 'app/services/browser-close/browser-close.service';
import { loadingInterceptor } from 'app/core/loading.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),

    // Register interceptors in desired order
    provideHttpClient(withInterceptors([
      loadingInterceptor,
      httpInterceptor,
      errorInterceptor
    ])),

    importProvidersFrom(
      MatToolbarModule,
      MatButtonModule,
      MatCardModule,
      MatInputModule,
      MatFormFieldModule,
      MatIconModule,
      ReactiveFormsModule
    ),

    {
      provide: OktaAuth,
      useFactory: () => new OktaAuth({
        issuer: environment.oktaIssuer,
        clientId: environment.oktaClientId,
      })
    },
    {
      provide: RxStomp,
      useFactory: rxStompFactory
    },
    provideEnvironmentInitializer(() => inject(BrowserCloseService))
  ]
}).catch(err => console.error(err));
